import * as React from 'react';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

import {CreateManagedMeetingButton} from './create-managed-meeting-button';

export function EmptyState() {
    return (
        <EmptyStateLarge
            title='Use managed meetings to create consistent meeting pages'
            subtitle='Create managed meetings for your team so they can focus on bookings instead'
            detailTextBullets={[
                'Configure meetings so that new users automatically have Scheduler meetings ready-to-go',
                'Ensure all meetings maintain consistency that align with your company’s standards',
            ]}
            cta={<CreateManagedMeetingButton size='xlarge' />}
            icon={<Illustration src='managed-meetings' width={300} />}
        />
    );
}
